/**
 * Whether the "Default bundle content" (`default_is_bundle_content`) field is
 * shown in the resource Details sidebar.
 *
 * `default_is_bundle_content` is a bundle-only setting that is unrelated to git
 * (it governs whether new records placed in the bundle default to being bundle
 * content), so it is shown for every bundle regardless of whether git is enabled
 * for it. The genuinely git-related container fields (default/force track-in-git,
 * max tracked record size) stay git-gated separately.
 *
 * (operator-task-fe-default-is-bundle-content-always-show)
 */
export const shouldShowDefaultIsBundleContentField = (resourceName: string): boolean =>
    resourceName === "bundle";
